import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../../store';

interface SuperAdminRouteProps {
  children: React.ReactNode;
}

/**
 * Route guard that only allows superadmin users.
 * Non-superadmin users are redirected to the home page.
 */
export const SuperAdminRoute: React.FC<SuperAdminRouteProps> = ({ children }) => {
  const user = useAppSelector(state => state.auth.user);

  if (user?.role !== 'superadmin') {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
